function PageNotFound({ onNavigate }) {
  return (
    <div className="section-wrap py-16">
      <section className="premium-panel p-10 text-center">
        <h1 className="font-serif text-5xl text-obsidian-950">Page Not Found</h1>
        <p className="mt-3 text-sm text-obsidian-700">The page you requested does not exist.</p>
        <button
          className="mt-5 rounded-2xl bg-obsidian-950 px-5 py-3 text-sm font-semibold text-cream-50"
          onClick={() => onNavigate("/")}
        >
          Return Home
        </button>
      </section>
    </div>
  );
}

export default PageNotFound;
